import { forwardRef } from 'react';

import { Box, TextField } from '@mui/material';
import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { RequiredField, TextInputProps } from '../../content/auth/signup';

const TextInput = forwardRef<HTMLInputElement, TextInputProps>((props, ref) => {
  const disabledStyle = props.disabled
    ? {
        backgroundColor: '#f5f5f5',
        cursor: 'not-allowed'
      }
    : {};

  return (
    <Box pb={2} style={{ ...(props.style ? props.style : {}) }}>
      <Box display={'flex'} alignItems={'center'} mb={1}>
        {props.icon}
        <label {...(props?.id ? { htmlFor: props?.id } : {})}>
          {props.label}
          {props.required ? <RequiredField>*</RequiredField> : ''}
        </label>
      </Box>
      <TextField
        {...(ref ? { inputRef: ref } : {})}
        // TODO: add id and name in all fields
        {...(props.id ? { id: props.id, name: props.id } : {})}
        style={{ width: '100%', ...disabledStyle }}
        {...(props.autoComplete
          ? {
              autoComplete: props.autoComplete
            }
          : {})}
        type={
          props.type === 'password'
            ? props.passwordVisible
              ? 'text'
              : 'password'
            : props.type
        }
        InputLabelProps={{ shrink: false }}
        variant="outlined"
        error={props.validateError}
        helperText={props.validateError ? props.validateErrormsg : ''}
        value={props.value}
        placeholder={props.placeholder}
        onChange={(e) => props.onChangeText(e.target.value)}
        {...(props.inputProps
          ? {
              InputProps: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={props.onIconClick}>
                      {props.passwordVisible ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </IconButton>
                  </InputAdornment>
                )
              }
            }
          : {})}
        {...(props.handleOnFocus
          ? {
              onFocus: props.handleOnFocus
            }
          : {})}
        {...(props.disabled
          ? {
              disabled: props.disabled
            }
          : {})}
        {...(props?.multiline ? { multiline: props?.multiline } : {})}
        {...(props?.rows ? { rows: props?.rows } : {})}
      />
      {props.instruction ? (
        <p
          style={{ ...(props.instructionStyle ? props.instructionStyle : {}) }}
        >
          {props.instruction}
        </p>
      ) : null}
    </Box>
  );
});

export default TextInput;
